import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';
import { AI_AUTOMATIONS_LOCAL_API_REQUESTS } from './constants';

/**
 * GET /nerobotti/automations/projects?businessId= — the company's sites a
 * task could be pointed at.
 *
 * Asked of the server rather than assembled from the projects the browser
 * happens to hold, so the picker and the sweep agree about what counts as one
 * of this company's live sites.
 */
export const getAutomationProjects = async ({ businessId }) => {
  const signedRequest = await createSignedGetRequest({
    apiPath: `nerobotti/automations/projects?businessId=${encodeURIComponent(
      businessId
    )}`,
    isLocalApiRequest: AI_AUTOMATIONS_LOCAL_API_REQUESTS,
  });
  const response = await axios(signedRequest);
  return response.data;
};
